<script setup>
// core
import {computed} from "vue";
import {useIntegrationPage} from '@/composables/useIntegrationPage.js'
import {MESSENGERS} from "@/constants.js";

import UnorderedListRecurring from "@/components/Recurring/UnorderedListRecurring.vue";

const CRM = {crm: "ConnectiveOne"};
const {getInstructionTexts} = useIntegrationPage()

const textBlock = computed(() => {
    return getInstructionTexts([
        MESSENGERS.VIBER,
        MESSENGERS.TELEGRAM,
        MESSENGERS.WHATSAPP,
    ], CRM.crm)
});
</script>

<template>
    <div class="wrapper">
        <h2 class="page_title">{{ $t("page.instruction_template.title", CRM) }}</h2>
        <div class="container_block">
            <UnorderedListRecurring :list="textBlock"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";
</style>
